import { render } from "./Home.vue?vue&type=template&id=e3b80f58&scoped=true&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=e3b80f58&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/draw-and-guess/draw-and-guess/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3b80f58"]])

export default __exports__